import { __awaiter } from "tslib";
import { SequenceTrackTitleFactory } from "./SequenceTrackTitleFactory";
export class InstanceSequenceTrackTitleFactory {
    constructor(entityInstanceTranslator) {
        this.trackTitleFactory = new SequenceTrackTitleFactory(entityInstanceTranslator);
    }
    getTrackTitle(alignmentQueryContext) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.trackTitleFactory.getTrackTitle(alignmentQueryContext);
        });
    }
    getTrackTitlePrefix(alignmentQueryContext) {
        return __awaiter(this, void 0, void 0, function* () {
            return "CHAIN";
        });
    }
    getTrackTitleFlagColor(alignmentQueryContext) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.trackTitleFactory.getTrackTitleFlagColor(alignmentQueryContext);
        });
    }
}
//# sourceMappingURL=InstanceSequenceTrackTitleFactory.js.map